import { Component } from 'react';
import { connect } from 'react-redux';

export default connect((state) => state)(
  class extends Component {
    handleChange = (ev) => {
      let chapterId = parseInt(
        ev.currentTarget.getAttribute('data-chapter-id'),
        10
      );
      this.props.onChange(chapterId || null);
    };

    render() {
      const { chapters, messages, selectedChapterId, theme } = this.props;

      return (
        <div className="chapters">
          <button
            className={
              'chapter-button focus-box-shadow' +
              (!selectedChapterId ? ' active' : '')
            }
            data-chapter-id={null}
            onClick={this.handleChange}
          >
            {messages.commonAllChapters}
          </button>
          {chapters.map((chapter) => (
            <button
              className={
                'chapter-button focus-box-shadow' +
                (selectedChapterId === chapter.id ? ' active' : '')
              }
              data-chapter-id={chapter.id}
              key={chapter.id}
              onClick={this.handleChange}
            >
              {`${chapter.number}. ${chapter.title}`}
            </button>
          ))}

          <style jsx>{`
            .chapters {
              background-color: ${theme.lightGreyLighter};
              border-radius: 5px;
              width: 240px;
            }
            .chapter-button {
              background-color: transparent;
              border: 0;
              color: ${theme.textColorLight};
              cursor: pointer;
              display: block;
              font-family: inherit;
              font-size: 1.4rem;
              font-weight: 600;
              outline: 0;
              padding: 12px 15px;
              text-align: left;
              transition: background-color 0.3s, color 0.3s;
              width: 100%;
            }
            .chapter-button:not(:first-child) {
              border-top: 1px solid white;
            }
            .chapter-button.active,
            .chapter-button:hover {
              color: ${theme.textColor};
              font-weight: 700;
            }
            .chapter-button:focus {
              box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.15);
            }
          `}</style>
        </div>
      );
    }
  }
);
